import { BlitScreenQuadCMD } from "./BlitScreenQuadCMD";
import { SetDefineCMD, SetShaderDataCMD } from "./SetShaderDataCMD";
import { DrawMeshCMD } from "./DrawMeshCMD";
import { DrawRenderCMD } from "./DrawRenderCMD";
import { SetGlobalShaderDataCMD } from "./SetGlobalShaderDataCMD";
import { DrawMeshInstancedCMD } from "./DrawMeshInstancedCMD";
import { RenderCapable } from "../../../../RenderEngine/RenderEnum/RenderCapable";
import { Color } from "../../../../maths/Color";
import { LayaGL } from "../../../../layagl/LayaGL";
import { ShaderDataType } from "../../../../RenderDriver/DriverDesign/RenderDevice/ShaderData";
import { SetRTCMD } from "./SetRenderTargetCMD";
import { DrawRenderElementCMD } from "./DrawRenderElemenetCMD";
import { ComputeCommandBufferCMD } from "./ComputeCommandBufferCMD";
export class CommandBuffer {
    constructor(name = null, shadowCaster = false) {
        this._shadow = false;
        this._camera = null;
        this._commands = [];
        this._renderCMDs = [];
        this._name = name;
        this._shadow = shadowCaster;
    }
    get name() {
        return this._name;
    }
    get casterShadow() {
        return this._shadow;
    }
    get context() {
        return this._context;
    }
    set context(value) {
        this._context = value;
    }
    _apply(render = false) {
        for (var i = 0, n = this._commands.length; i < n; i++) {
            let cmd = this._commands[i];
            cmd.run && cmd.run();
        }
        render && this.context._contextOBJ.runCMDList(this._renderCMDs);
    }
    _applyOne() {
        if (this._commands.length) {
            var cmd = this._commands.shift();
            cmd.run && cmd.run();
            cmd.getRenderCMD && this.context._contextOBJ.runOneCMD(this._renderCMDs.shift());
            cmd.recover();
        }
        return this._commands.length > 0;
    }
    getCommandsSize() {
        return this._commands.length;
    }
    setShaderDataTexture(shaderData, nameID, source) {
        let cmd = SetShaderDataCMD.create(shaderData, nameID, source, ShaderDataType.Texture2D, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    setGlobalTexture(nameID, source) {
        let cmd = SetGlobalShaderDataCMD.create(nameID, source, ShaderDataType.Texture2D, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    setShaderDataColor(shaderData, nameID, value) {
        let cmd = SetShaderDataCMD.create(shaderData, nameID, value, ShaderDataType.Color, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    setGlobalColor(nameID, source) {
        let cmd = SetGlobalShaderDataCMD.create(nameID, source, ShaderDataType.Color, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    setShaderDataVector(shaderData, nameID, value) {
        let cmd = SetShaderDataCMD.create(shaderData, nameID, value, ShaderDataType.Vector4, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    setGlobalVector(nameID, source) {
        let cmd = SetGlobalShaderDataCMD.create(nameID, source, ShaderDataType.Vector4, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    setShaderDataVector3(shaderData, nameID, value) {
        let cmd = SetShaderDataCMD.create(shaderData, nameID, value, ShaderDataType.Vector3, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    setGlobalVector3(nameID, source) {
        let cmd = SetGlobalShaderDataCMD.create(nameID, source, ShaderDataType.Vector3, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    setShaderDataVector2(shaderData, nameID, value) {
        let cmd = SetShaderDataCMD.create(shaderData, nameID, value, ShaderDataType.Vector2, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    setGlobalVector2(nameID, source) {
        let cmd = SetGlobalShaderDataCMD.create(nameID, source, ShaderDataType.Vector2, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    setShaderDataNumber(shaderData, nameID, value) {
        let cmd = SetShaderDataCMD.create(shaderData, nameID, value, ShaderDataType.Float, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    setGlobalNumber(nameID, source) {
        let cmd = SetGlobalShaderDataCMD.create(nameID, source, ShaderDataType.Float, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    setShaderDataInt(shaderData, nameID, value) {
        let cmd = SetShaderDataCMD.create(shaderData, nameID, value, ShaderDataType.Int, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    setGlobalInt(nameID, source) {
        let cmd = SetGlobalShaderDataCMD.create(nameID, source, ShaderDataType.Int, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    setShaderDataMatrix(shaderData, nameID, value) {
        let cmd = SetShaderDataCMD.create(shaderData, nameID, value, ShaderDataType.Matrix4x4, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    setShaderDefine(shaderData, define, value) {
        let cmd = SetDefineCMD.create(shaderData, define, value, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    setGlobalMatrix(nameID, source) {
        let cmd = SetGlobalShaderDataCMD.create(nameID, source, ShaderDataType.Matrix4x4, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    blitScreenQuad(source, dest, offsetScale = null, shader = null, shaderData = null, subShader = 0) {
        let cmd = BlitScreenQuadCMD.create(source, dest, offsetScale, shader, shaderData, subShader, BlitScreenQuadCMD.SCREENTYPE_QUAD, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    blitScreenQuadByMaterial(source, dest, offsetScale = null, material = null, subShader = 0) {
        var shader;
        var shaderData;
        if (material) {
            shader = material._shader;
            shaderData = material.shaderData;
        }
        let cmd = BlitScreenQuadCMD.create(source, dest, offsetScale, shader, shaderData, subShader, BlitScreenQuadCMD.SCREENTYPE_QUAD, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    blitScreenTriangle(source, dest, offsetScale = null, shader = null, shaderData = null, subShader = 0) {
        let cmd = BlitScreenQuadCMD.create(source, dest, offsetScale, shader, shaderData, subShader, BlitScreenQuadCMD.SCREENTYPE_TRIANGLE, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    appatchComputeCommand(source) {
        let cmd = ComputeCommandBufferCMD.create(source);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    setRenderTarget(renderTexture, clearColor, clearDepth, backgroundColor = Color.BLACK, depth = 1) {
        let cmd = SetRTCMD.create(renderTexture, clearColor, clearDepth, false, backgroundColor, depth, 0, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    drawMesh(mesh, matrix, material, submeshIndex, subShaderIndex) {
        let cmd = DrawMeshCMD.create(mesh, matrix, material, submeshIndex, subShaderIndex, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    drawRender(render, material, subMeshIndex = 0) {
        let cmd = DrawRenderCMD.create(render, material, subMeshIndex, this);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    drawRenderElement(renderElement) {
        let cmd = DrawRenderElementCMD.create(renderElement);
        this._commands.push(cmd);
        cmd.getRenderCMD && this._renderCMDs.push(cmd.getRenderCMD());
    }
    drawMeshInstance(mesh, subMeshIndex = 0, matrixs, material, subShaderIndex = 0, instanceProperty, drawnums) {
        if (!LayaGL.renderEngine.getCapable(RenderCapable.DrawElement_Instance))
            return null;
        var drawMeshInstancedCMD = DrawMeshInstancedCMD.create(mesh, subMeshIndex, matrixs, material, subShaderIndex, instanceProperty, drawnums, this);
        this._commands.push(drawMeshInstancedCMD);
        drawMeshInstancedCMD.getRenderCMD && this._renderCMDs.push(drawMeshInstancedCMD.getRenderCMD());
        return drawMeshInstancedCMD;
    }
    addCustomCMD(command) {
        command._commandBuffer = this;
        this._commands.push(command);
        command.getRenderCMD && this._renderCMDs.push(command.getRenderCMD());
    }
    clear() {
        for (var i = 0, n = this._commands.length; i < n; i++)
            this._commands[i].recover();
        this._commands.length = 0;
        this._renderCMDs.length = 0;
    }
}
